// @flow
import React, {Component} from 'react'
import type {Node} from 'react'

import DisabledButtonWithTooltip from '../DisabledButtonWithTooltip'

type Props = {
  block?: boolean,
  className?: string,
  children: Node,
  color?: string,
  id: string,
  placement?: string,
  size?: string,
  title: string,
  ...
}

class DisabledForRestrictedPlanButton extends Component<Props> {
  renderDisabledButton(): Node {
    const {children, ...buttonProps} = this.props

    return (
      <DisabledButtonWithTooltip
        {...buttonProps}
        tooltip={I18n.t('tensions.my_tensions.upgrade_to_premium')}
      />
    )
  }

  render(): Node {
    if (window.gf.app.orgOnRestrictedPlan())
      return this.renderDisabledButton()

    return this.props.children
  }
}

export default DisabledForRestrictedPlanButton
